export default __webpack_public_path__ + "static/media/calls.e2c5556a.mp3";